import { render, staticRenderFns } from "./NeiBuFile8.vue?vue&type=template&id=f637f084&scoped=true&"
import script from "./NeiBuFile8.vue?vue&type=script&lang=js&"
export * from "./NeiBuFile8.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuFile8.vue?vue&type=style&index=0&id=f637f084&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f637f084",
  null
  
)

export default component.exports